import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

export default function OptionsBuilder({ options, onChange, className }) {
  const { t } = useTranslation();
  const handleTextChange = (index, text) => {
    const updated = options.map((opt, i) =>
      i === index ? { ...opt, text } : opt
    );
    onChange(updated);
  };

  const handleCorrectChange = (index) => {
    const updated = options.map((opt, i) => ({
      ...opt,
      correct: i === index,
    }));
    onChange(updated);
  };

  const handleRemove = (index) => {
    if (options.length <= 2) return;
    onChange(options.filter((_, i) => i !== index));
  };

  const handleAdd = () => {
    onChange([...options, { text: '', correct: false }]);
  };

  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  return (
    <div className={cn('space-y-2', className)}>
      {options.map((opt, index) => (
        <div key={index} className="flex items-center gap-2">
          {/* Correct marker */}
          <button
            type="button"
            onClick={() => handleCorrectChange(index)}
            className={cn(
              'flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-xs font-semibold transition-all duration-200',
              opt.correct
                ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900'
                : 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'
            )}
            title={opt.correct ? t('questions.correctOption') : t('questions.markCorrect')}
          >
            {letters[index] || index + 1}
          </button>

          {/* Option text */}
          <input
            type="text"
            value={opt.text}
            onChange={(e) => handleTextChange(index, e.target.value)}
            placeholder={`Option ${letters[index] || index + 1}`}
            className={cn(
              'flex-1 px-3 py-1.5 rounded-lg text-sm',
              'bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600',
              'text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500',
              'focus:outline-none focus:border-gray-400 dark:focus:border-gray-500',
              'transition-all duration-200'
            )}
          />

          {/* Correct indicator */}
          {opt.correct && (
            <span className="text-xs text-gray-500 dark:text-gray-400 flex-shrink-0">
              ✓
            </span>
          )}

          {/* Remove */}
          {options.length > 2 && (
            <button
              type="button"
              onClick={() => handleRemove(index)}
              className="flex-shrink-0 p-1 text-gray-300 hover:text-red-500 dark:text-gray-600 dark:hover:text-red-400 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={handleAdd}
        className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors flex items-center gap-1 pt-1"
      >
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        {t('questions.addOption')}
      </button>
    </div>
  );
}
